import { render, staticRenderFns } from "./TeamDetail.vue?vue&type=template&id=51120f47&scoped=true&"
import script from "./TeamDetail.vue?vue&type=script&lang=js&"
export * from "./TeamDetail.vue?vue&type=script&lang=js&"
import style0 from "./TeamDetail.vue?vue&type=style&index=0&id=51120f47&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51120f47",
  null
  
)

export default component.exports